import React from "react"
import { Link } from "gatsby"

import * as style from "./Header.module.scss"

const Header = ({
  children,
  stroke,
  centered,
  small,
  uppercase,
  right,
  light,
  to,
}) => (
  <header
    className={style.header}
    data-stroke={stroke === ""}
    data-centered={centered === ""}
    data-small={small === ""}
    data-uppercase={uppercase === ""}
    data-right={right === ""}
    data-light={light === ""}
  >
    {to
      && (
      <span>
        <Link to={to}>{children}</Link>
      </span>
      )}
    {!to
      && <span>{ children }</span>}
  </header>
)

export default Header
